import { isEmpty } from 'lodash-es';
import { useCallback, useEffect } from 'react';
import { poolingForEmails } from 'wisestep-api';

import { useNewEmailStore } from './Util/NewEmailStore';

export const PollingHandler = () => {
  const KEY_LAST_EXECUTION_TIME = 'lastExecutionTime';
  const EXECUTION_INTERVAL_MS = 0.17 * 60 * 1000;
  const configuredImapAccounts = useNewEmailStore((state) => state.configuredImapAccounts);

  const pollingFunction = useCallback(() => {
    const pollingForNewData = async () => {
      if (!isEmpty(configuredImapAccounts))
        await poolingForEmails(configuredImapAccounts[0]?.recruiterEmail ?? '');
    };
    pollingForNewData();
  }, [configuredImapAccounts]);

  const canExecute = useCallback(() => {
    const lastExecutionTime = localStorage.getItem(KEY_LAST_EXECUTION_TIME);
    const now = new Date().getTime();
    if (!lastExecutionTime || now - Number(lastExecutionTime) >= EXECUTION_INTERVAL_MS) {
      localStorage.setItem(KEY_LAST_EXECUTION_TIME, now.toString());
      return true;
    }
    return false;
  }, [EXECUTION_INTERVAL_MS]);

  const startExecution = useCallback(() => {
    if (canExecute()) {
      pollingFunction();
    }
  }, [canExecute, pollingFunction]);

  useEffect(() => {
    if (!isEmpty(configuredImapAccounts)) {
      const intervalId = setInterval(startExecution, EXECUTION_INTERVAL_MS);
      return () => clearInterval(intervalId);
    }
  }, [EXECUTION_INTERVAL_MS, configuredImapAccounts, startExecution]);

  return <></>;
};
